import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IClientPortalJobsService } from "services/ClientPortalJobsService";
import { ClientPortalJobFiltersModel, ClientPortalJobOverviewModel } from "services/api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { RootState } from "setup/redux/RootReducer";

type JobsTableSliceState = {
  Jobs: Array<ClientPortalJobOverviewModel>;
  IncludeArchived: boolean;
  Loading: boolean;
};

const initialState: JobsTableSliceState = {
  Jobs: new Array<ClientPortalJobOverviewModel>(),
  IncludeArchived: false,
  Loading: false,
};

export const JobsTableSlice = createSlice({
  name: "JobsTable",
  initialState,
  reducers: {
    setIncludeArchived: (state, action) => {
      state.IncludeArchived = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getJobs.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getJobs.fulfilled, (state, action) => {
        state.Jobs = action.payload;
        state.Loading = false;
      })
      .addCase(getJobs.rejected, (state) => {
        state.Jobs = new Array<ClientPortalJobOverviewModel>();
        state.Loading = false;
      });
  },
});

export const getJobs = createAsyncThunk<ClientPortalJobOverviewModel[], { jobsFilters: ClientPortalJobFiltersModel }>(
  "JobsTable/GetJobs",
  async ({ jobsFilters }) => {
    const jobsService = container.get<IClientPortalJobsService>(SERVICE_TYPES.ClientPortalJobsService);

    return await jobsService.getJobs(jobsFilters);
  }
);

export const { setIncludeArchived } = JobsTableSlice.actions;
export const selectJobs = (state: RootState) => state.jobsTable.Jobs;
export const selectIncludeArchived = (state: RootState) => state.jobsTable.IncludeArchived;
export const selectLoadingJobs = (state: RootState) => state.jobsTable.Loading;

export default JobsTableSlice.reducer;
